export const isProduction = () =>
  process.env.NEXT_PUBLIC_APP_ENV === 'production' ||
  process.env.NEXT_PUBLIC_LIVE_OVERRIDE === '1'

export const isDevelopment = () =>
  process.env.NEXT_PUBLIC_APP_ENV === 'development' &&
  process.env.NEXT_PUBLIC_LIVE_OVERRIDE !== '1'

export const isLocalhost = () =>
  process.env.NEXT_PUBLIC_APP_ENV === 'localhost' &&
  process.env.NEXT_PUBLIC_LIVE_OVERRIDE !== '1'
